module.exports = __webpack_public_path__ + "img/house_img2.a10c49c3.png";